import confsService from '@/api/confsService'
import { CHANNEL_OPTIONS, CHANNEL_OPTIONS_EXTERIOR } from '@/utils/campaignOptions'

/**
 *  ConfDetail script file
**/

export default {
  name: 'ConfDetail',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      conf: {
        profile: {
          title: null
        }
      },
      channelTypes: Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }),
      emails: {},
      exteriorAgencyEmails: [],
      awsAccounts: [],
      terrUnits: []
    }
  },
  computed: {
  },
  async mounted () {
    this.$emit('selectTab', { id: 'confs' })
    this.conf = await confsService.getConf({ id: this.$route.params.confid })
    Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }).forEach(co => {
      this.emails[co] = []
    })
    if (this.conf.profile.emails) {
      Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }).forEach(co => {
        if (this.conf.profile.emails[co]) {
          this.emails[co] = this.conf.profile.emails[co].split(',')
        }
      })
    }
    if (this.conf.profile.gaw_extra_accounts) {
      this.awsAccounts = this.conf.profile.gaw_extra_accounts
    }
    if (this.conf.profile.terr_units) {
      this.terrUnits = this.conf.profile.terr_units
    }
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    }
  }
}
